import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { makeReplaceableComponent } from "../../helpers/components";
function TooltipContent({ children }) {
    return _jsx(_Fragment, { children: children });
}
export default makeReplaceableComponent("TooltipContent", TooltipContent);
